module.exports = __webpack_public_path__ + "img/industriale.85dcfdb0.png";